import { FunctionComponent, useState, useEffect } from 'react';
import * as vp from 'vopay';
import styles from './TransactionsOverviewContainer.module.scss';
import TransactionsOverviewTable from './TransationsOverViewTable';
import useFetchTransactionsOverview from '../../../../hooks/useApi/useFetchTransactionsOverview';
import { useTranslation } from 'react-i18next';

const { Tabs, withStyles, NoData, Box, SubTitle } = vp;
const classes = withStyles(styles);

type ValueTabContents = {
  Number: React.JSX.Element;
  Volume: React.JSX.Element;
};

type PeriodTabContents = {
  Yearly: React.JSX.Element;
  Monthly: React.JSX.Element;
  Weekly: React.JSX.Element;
};

type FC = FunctionComponent;

const TransactionsOverviewContainer: FC = () => {
  const [valueTab, setValueTab] = useState<keyof ValueTabContents>('Number');
  const [periodTab, setPeriodTab] = useState<keyof PeriodTabContents>('Yearly');
  const [transactionsData, fetchTransactionsOverview] = useFetchTransactionsOverview({});
  const { t } = useTranslation('translations', { keyPrefix: 'HomePage.TransactionOverviewWidget' });

  const handleValueTabClick = (tab: keyof ValueTabContents) => {
    setValueTab(tab);
  };

  const handlePeriodTabClick = (tab: keyof PeriodTabContents) => {
    setPeriodTab(tab);
  };

  useEffect(() => {
    fetchTransactionsOverview();
  }, []);

  return (
    <div className={styles.container}>
      <SubTitle subTitle={t('title')} variant="bold" />
      <Box flx="col" mt="md">
        <Tabs
          variant="chart"
          tabs={[
            {
              label: t('amountTab'),
              onClick: () => handleValueTabClick('Number'),
            },
            {
              label: t('volumeTab'),
              onClick: () => handleValueTabClick('Volume'),
            },
          ]}
        />

        {transactionsData.Statistics && Object.keys(transactionsData.Statistics).length !== 0 ? (
          <div className={classes('tableContainer', 'scrollbar')}>
            <TransactionsOverviewTable valueTab={valueTab} periodTab={periodTab} transactionsData={transactionsData} />
          </div>
        ) : (
          <NoData />
        )}

        <Tabs
          variant="chart"
          tabs={[
            {
              label: t('yearlyTab'),
              onClick: () => handlePeriodTabClick('Yearly'),
            },
            {
              label: t('monthlyTab'),
              onClick: () => handlePeriodTabClick('Monthly'),
            },
            {
              label: t('weeklyTab'),
              onClick: () => handlePeriodTabClick('Weekly'),
            },
          ]}
        />
      </Box>
    </div>
  );
};

export default TransactionsOverviewContainer;
